import InviteItemContainer from './InviteItemContainer';

export default InviteItemContainer;
